export const CONVERSATION_PANEL_STRINGS = {
	NO_PROPOSALS_ALT: 'Homem acenando proximo ao carro',
	NO_PROPOSALS_HEADING: 'Opa!',
	NO_PROPOSALS_TEXT: 'Você não recebeu nenhuma proposta ainda, mas deve estar muito perto disso :)',
	WELCOME_ALT: 'Imagem de duas pessoas no carro vermelho',
	WELCOME_HEADING: 'Boas-vindas ao Chat seguro!',
	WELCOME_TEXT: 'Converse e negocie com toda segurança ao comprar ou vender.',
} as const;
